module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch3"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('p', {
    staticClass: "centerImage0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/ch3.jpg",
      "width": "5%"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That’s enough out of you three! You’re always making trouble,” the red-faced Mr. Dunning sputters. “If you hate history so much, you can just wait for the rest of us in the lobby.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh, brother,” you groan. “There goes our fun.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Minutes later, the bus pulls up to a stone building. Mr. Dunning leads the class into the lobby of the Wicked Wax Museum.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A scowling woman in a purple turban and gold bracelets sits inside a ticket booth. “These three students will not be going in,” Mr. Dunning tells her. He turns to you, Jake, and Liz and points to a bench by the wall. “Sit there, you little monsters. And you’d better still be sitting there when I come back!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The class leaves you behind as they enter the Hall of Historical Exhibits. A red door closes after them. Jake manages to sit still for a few minutes. Then he jumps up and says, “I think it’s time for us to take a little tour of our own.”")]), _vm._v(" "), _c('p', {
    staticClass: "extractLetterText",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Turn to "), _c('span', {
    attrs: {
      "href": "#/e9780545841733_ch075",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PAGE 75")]), _vm._v(".")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74a7afbe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9780545841733_ch003.vue
// module id = 72
// module chunks = 0